<template>
  <qx-card-form title="保养信息">
    <qx-custom-form
      :noSubBtn="true"
      ref="baseForm"
      :formData="baseForm"
      labelWidth="120px"
    >
      <section slot="serviceSite" slot-scope="prop">
        <ChooseSite
            :isRadio="true"
            v-model="prop.form.serviceSite"
            :otherSearchData="{isInventory:true}"
            :placeholder="'请选择保养服务点'"
            @change="chooseSiteChange"
        />
      </section>
    </qx-custom-form>
    <button @click="getDataTest" class="test-btn">测试提交参数</button>
  </qx-card-form>
</template>

<script>
import ChooseSite from 'components/choose/site';
import {dealNumber} from '@qx/utils';
export default {
  components: {
    ChooseSite,
  },
  data () {
    return {
      maintainMethod: '',
      otherFormData: {
        serviceID: '', // 服务商id
        serviceName: '', // 服务商名称
      },
      baseForm: {
        suitTypeOptions: [],
        form: [
          {
            label: '保养日期',
            value: 'maintenanceDate',
            type: 'date',
            placeholder: '请选择保养日期',
            attr: {
              time: '00:00:00',
            },
          },
          {
            label: '行驶里程',
            value: 'drivingDistance',
            type: 'input',
            placeholder: '请输入保养时里程',
            onInput: (drivingDistance) => {
              this.$refs.baseForm.setVal('drivingDistance', dealNumber(drivingDistance, false));
            },
          },
          {
            label: '保养项目',
            value: 'maintenanceProject',
            type: 'input',
            placeholder: '支持50个字输入',
            attr: {
              maxlength: 50,
            },

          },
          {
            label: '金额（元）',
            value: 'amount',
            type: 'input',
            placeholder: '请输入保养费用',
            onInput: (amount) => {
              this.$refs.baseForm.setVal('amount', dealNumber(amount, false));
            },
          },
          {
            label: '服务站点',
            value: 'serviceSite',
            default: {},
            slot: true,
          },
          {
            label: '备注',
            value: 'remark',
            type: 'input',
            placeholder: '支持50个字输入',
          },
          {
            label: '保养人员',
            value: 'maintenancePersonnel',
            type: 'input',
            placeholder: '请输入保养人员姓名',
          },
          {
            label: '下次保养日期',
            value: 'nextMaintenanceDate',
            type: 'date',
            placeholder: '请选择下次保养日期',
            attr: {
              time: '00:00:00',
            },
            hide: true,
          },
          {
            label: '下次保养里程数',
            value: 'mileageForNextMaintenance',
            type: 'input',
            placeholder: '请输入下次保养累计里程',
            hide: true,
          },
        ],
        rules: {
          maintenanceDate: [
            { required: true, message: '请选择保养日期', trigger: 'blur' },
          ],
          drivingDistance: [
            { required: true, message: '请输入保养时里程', trigger: 'blur' },
          ],
          maintenanceProject: [
            { required: true, message: '请输入保养项目', trigger: 'blur' },
          ],
          amount: [
            { required: true, message: '请输入保养费用', trigger: 'blur' },
          ],
          maintenancePersonnel: [
            { required: true, message: '请输入保养人员姓名', trigger: 'blur' },
          ],
          nextMaintenanceDate: [
            { required: true, message: '请选择下次保养日期', trigger: 'blur' },
          ],
          mileageForNextMaintenance: [
            { required: true, message: '请输入下次保养累计里程', trigger: 'blur' },
          ],
        },
      },
    };
  },
  methods: {
    async getDataTest () {
      this.sub();
    },
    // 根据“保养方式”类型，设置“下次保养日期”或“下次保养里程数”表单显示或隐藏
    setFormVal (plateNumberInfo) {
      this.maintainMethod = plateNumberInfo.maintainMethod || plateNumberInfo;
      this.setFormAttrVal({
        form: this.baseForm,
        attr: 'hide',
        value: plateNumberInfo.maintainMethod === 1 || plateNumberInfo === 1,
        names: ['mileageForNextMaintenance'],
      });
      this.setFormAttrVal({
        form: this.baseForm,
        attr: 'hide',
        value: plateNumberInfo.maintainMethod === 2 || plateNumberInfo === 2,
        names: ['nextMaintenanceDate'],
      });
      this.$refs.baseForm.setVal('mileageForNextMaintenance', '');
      this.$refs.baseForm.setVal('nextMaintenanceDate', '');
    },
    chooseSiteChange (selectedSiteInfo) {
      this.otherFormData.serviceID = selectedSiteInfo.serviceUserId;
      this.otherFormData.serviceName = selectedSiteInfo.serviceName;
    },
    // 统一处理数据格式
    async handleSubData (cache) {
      let formData;
      if (cache) {
        formData = await this.$refs.baseForm.getVal();
      } else {
        formData = await this.$refs.baseForm.sub();
      }
      if (formData || cache) {
        if (formData.serviceSite) {
          formData.serviceSite = formData.serviceSite.productName;
        }
        formData.maintenanceDate = this.formatDate(formData.maintenanceDate);
        formData.nextMaintenanceDate = this.formatDate(formData.nextMaintenanceDate);
        formData = {
          ...formData,
          ...this.otherFormData,
        };
      }
      return formData;
    },
    async cacheData () {
      const formData = await this.handleSubData(true);
      if (formData.drivingDistance) {
        formData.drivingDistance = formData.drivingDistance * 1000;
      }
      if (formData.mileageForNextMaintenance) {
        formData.mileageForNextMaintenance = formData.mileageForNextMaintenance * 1000;
      }
      if (formData.amount) {
        formData.amount = formData.amount * 100;
      }
      return formData;
    },
    async sub () {
      let formData = await this.handleSubData();
      if (this.maintainMethod === 1) {
        formData.mileageForNextMaintenance = '';
      } else {
        formData.nextMaintenanceDate = '';
      }
      return formData;
    },
    async init (data = {}) {
      this.$refs.baseForm.reset();
      if (data.vehicle) {
        this.setFormVal(data.vehicle.maintainMethod || 1);
        data.drivingDistance = data.drivingDistance / 1000;
        data.mileageForNextMaintenance = data.mileageForNextMaintenance / 1000;
        data.amount = data.amount / 100;
        data.serviceSite = {
          productName: data.serviceSite,
        };
        this.setFormValFromData(this.otherFormData, data);
        this.$refs.baseForm.setVal(data);
      } else {
        if (!this.$route.query.plateNumber) {
          this.setFormVal(1);
        }
      }

    },
  },
};
</script>

<style scoped lang="scss">
</style>
